import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { EventBookingProtocol } from './event-booking-protocol.js';
import { EventBookingStrategy } from './event-booking-strategy.js';

export class TicketsAndProductsEventBookingProtocol extends EventBookingProtocol {
  static readonly TYPE_ID: string = '0e62f05968bd48d4b99e0e1ce0acd3bd';

  public readonly strategy: EventBookingStrategy = EventBookingStrategy.TicketsAndProducts;

  private constructor(
    public readonly deferOrderCompletion: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketsAndProductsEventBookingProtocol.TYPE_ID;
  }

  static create(args?: {
    deferOrderCompletion?: boolean,
  }): TicketsAndProductsEventBookingProtocol {
    return new TicketsAndProductsEventBookingProtocol(
        args?.deferOrderCompletion ?? false,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketsAndProductsEventBookingProtocol {
    return new TicketsAndProductsEventBookingProtocol(
        MapUtils.get<boolean>(map, 'deferOrderCompletion'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'strategy': fromEnumAsString(this.strategy),
      'deferOrderCompletion': this.deferOrderCompletion,
    };
  }

  clone(): this {
    return new TicketsAndProductsEventBookingProtocol(
        this.deferOrderCompletion,
    ) as this;
  }

  isSame(other: TicketsAndProductsEventBookingProtocol): boolean {
    if(this === other) {
      return true;
    }

    return other.strategy === this.strategy &&
      other.deferOrderCompletion === this.deferOrderCompletion;
  }

  copyWith(opts?: {
    deferOrderCompletion?: boolean,
  }): this {
    return new TicketsAndProductsEventBookingProtocol(
        opts?.deferOrderCompletion ?? this.deferOrderCompletion,
    ) as this;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof TicketsAndProductsEventBookingProtocol;
  }

  static assertType(order: DataModel): order is TicketsAndProductsEventBookingProtocol {
    return order instanceof TicketsAndProductsEventBookingProtocol;
  }
}

export class TicketsAndProductsEventBookingProtocolBuilder extends DataModelBuilder<TicketsAndProductsEventBookingProtocol> {
  build(context: SerializationContext, map: SerializedData): TicketsAndProductsEventBookingProtocol {
    return TicketsAndProductsEventBookingProtocol.fromMap(context, map);
  }
}
